const edit_image_AI_page = {
  edit_image: 'Editar la imagen',
  regenerated_image: 'Re-generar la imagen',
}

export default edit_image_AI_page
